"use client";

import { HorizontalCategoricalBar } from "@/components/charts/HorizontalCategoricalBar";
import { getPalette } from "@/lib/palette";
import { usePrefersDark } from "@/lib/usePrefersDark";

export type EngagementRow = {
  category: string;
  count: number;
  share: number;
};

type Props = {
  data: EngagementRow[];
  total: number;
};

type Meta = { share: number; total: number };

export function EngagementBarChart({ data, total }: Props) {
  const p = getPalette(usePrefersDark());
  const max = data.reduce((m, r) => Math.max(m, r.count), 0);
  const xMax = Math.ceil((max * 1.12) / 100) * 100;

  const rows = data.map((r) => ({
    label: r.category,
    value: r.count,
    color: p.teal,
    meta: { share: r.share, total } as Meta,
  }));

  return (
    <HorizontalCategoricalBar<Meta>
      data={rows}
      height={320}
      valueDomain={[0, xMax]}
      xTickFormatter={(v) => `${v}`}
      valueLabelFormatter={(v, row) => {
        const pct = ((v / (row.meta?.total ?? total)) * 100).toFixed(1);
        return `${v.toLocaleString("en-CA")} (${pct}%)`;
      }}
      tooltipLabel="Participants"
      tooltipValueFormatter={(v, row) => {
        const t = row.meta?.total ?? total;
        const pct = ((row.meta?.share ?? v / t) * 100).toFixed(1);
        return `${v.toLocaleString("en-CA")} of ${t.toLocaleString("en-CA")} (${pct}%)`;
      }}
      categoryWidth={170}
    />
  );
}
